'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiBeer = function TiBeer(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.7 27.5c0 0.5-0.4 0.8-0.9 0.8s-0.8-0.3-0.8-0.8v-10c0-0.5 0.4-0.8 0.8-0.8s0.9 0.3 0.9 0.8v10z m3.3 0c0 0.5-0.4 0.8-0.8 0.8s-0.9-0.3-0.9-0.8v-10c0-0.5 0.4-0.8 0.9-0.8s0.8 0.3 0.8 0.8v10z m3.3 0c0 0.5-0.3 0.8-0.8 0.8s-0.8-0.3-0.8-0.8v-10c0-0.5 0.3-0.8 0.8-0.8s0.8 0.3 0.8 0.8v10z m7.5-17.5h-0.8v-1.7c0-1.8-1.5-3.3-3.3-3.3h-15c-1.9 0-3.4 1.5-3.4 3.3v21.7c0 2.8 2.3 5 5 5h11.7c2.8 0 5-2.2 5-5h0.8c3.3 0 5.9-2.6 5.9-5.8v-8.4c0-3.2-2.6-5.8-5.9-5.8z m-19.1-1.7h15v1.7h-7.4l-0.2 0.6c-0.3 0.7-1.1 1.2-1.9 1l-0.6-0.1-0.3 0.5c-0.4 0.8-1.2 1.3-2.1 1.3-1.4 0-2.5-1.1-2.5-2.5v-2.5z m15 21.7c0 0.9-0.8 1.7-1.7 1.7h-11.7c-0.9 0-1.6-0.8-1.6-1.7v-15.8c0.7 0.5 1.5 0.8 2.5 0.8 1.3 0 2.5-0.6 3.3-1.7 1.2 0 2.3-0.6 2.9-1.6h6.3v18.3z m6.6-5.8c0 1.3-1.1 2.5-2.5 2.5h-2.5v-13.4h2.5c1.4 0 2.5 1.2 2.5 2.5v8.4z' })
        )
    );
};

exports.default = TiBeer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/beer.js
// module id = 3763
// module chunks = 0